import { render, staticRenderFns } from "./healthcare-pro-tip.vue?vue&type=template&id=26cca4d7&scoped=true&"
import script from "./healthcare-pro-tip.vue?vue&type=script&lang=js&"
export * from "./healthcare-pro-tip.vue?vue&type=script&lang=js&"
import style0 from "./healthcare-pro-tip.vue?vue&type=style&index=0&id=26cca4d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cca4d7",
  null
  
)

export default component.exports